import React, { PureComponent } from 'react'
import './Layout.scss'
import classNames from 'classnames'
import { Layout as AntLayout } from 'antd'
import ContainerDimensions from 'react-container-dimensions'
const { Header, Footer, Sider, Content } = AntLayout

export default class Layout extends PureComponent {
  render() {
    const { className } = this.props
    const LayoutClassName = classNames(className, 'pan-layout')
    const LayoutProps = {
      className: LayoutClassName
    }
    return <AntLayout {...this.props} {...LayoutProps} />
  }
}

Object.assign(Layout, {
  Header, Footer, Sider, Content, ContainerDimensions
})
Layout.AntLayout = AntLayout
